<template>
  <modal-action-form :modal-id="modalId" :show-on-mount="true" size="sm"
                     :title="i18n.t('petitions.comments.flags.new.flag_comment')"
                     :use-bot-protection-if-available="true"
                     captcha-action="comment_flag"
                     :submit-action="createFlagAction"
                     @clear="$emit('closed')">
    <template #body>
      <div class="mb-4">
        {{ i18n.t('petitions.comments.flags.new.explanation') }}
      </div>
    </template>
  </modal-action-form>
</template>

<script>
import ModalActionForm from '@/components/modal-action-form'
import { mapActions } from 'vuex'

export default {
  components: { ModalActionForm },

  props: {
    commentId: {
      type: Number,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
    petitionSlug: {
      type: String,
      required: true
    }
  },

  emits: ['closed'],

  methods: {
    ...mapActions('comments', ['flagComment']),

    createFlagAction: async function({ friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
      try {
        await this.flagComment({
          petitionSlug: this.petitionSlug,
          commentId: this.commentId,
          friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken
        })
      }
      catch (err) {
        let validationErrors = err.info.errors

        if (validationErrors.flagFriendlyCaptchaVerifyResult ||
            validationErrors.flagRecaptchaScore ||
            validationErrors.flagHcaptchaVerifyResult ||
            validationErrors.flagTurnstileVerifyResult) {

          // The flag was rejected by bot protection.
          // Throw an error with a message, which will be picked up and displayed by ModalActionForm.
          throw new Error(this.i18n.t(
            'public.bot_protection.rejected',
            {org_name: this.agraConfiguration.organisationName}
          ))
        } else {
          throw err
        }
      }
    }
  }
}
</script>
